<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoEditar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso a essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoEditar">
			<form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
				<div class="formgroup" >
				</div>
				<div class="formgroup">
					<div class="flex justify-content-center" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="col-12 md:col-12" *ngIf="messagemVisivel">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true">
							</p-messages>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="grupo && !loading">
						<div class="field col-12 md:col-6">
							<label htmlFor="descricao">Descrição do Grupo</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite a descrição do Fabricante" name="descricao" ngModel
								[(ngModel)]="grupo.descricao" #descricao="ngModel" required />
							<div *ngIf="descricao.hasError('required') && descricao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="planoSelecionado">Tipo do Grupo</label>
							<p-dropdown [options]="tipos" optionLabel="descricao" [filter]="true"
								emptyFilterMessage="Nenhum registro" name="planoSelecionado" ngModel
								[(ngModel)]="grupo.planoContaEmpresa" [disabled]="listaSubgrupos.length > 0">
							</p-dropdown>
						</div>

						<div class="field col-12 md:col-6" *ngIf="tributacoes.length > 1">
							<label htmlFor="tributacaoEmpresa">Tributação</label>
							<p-dropdown [options]="tributacoes" optionLabel="razaoSocial" [filter]="true"
								emptyFilterMessage="Nenhum registro" name="tributacaoEmpresa" ngModel
								[(ngModel)]="grupo.tributacaoEmpresa">
							</p-dropdown>
						</div>

					</div>
					<div class="card col-12" *ngIf="grupo && !loading">
						<div class=" components p-fluid p-formgrid grid">
							<div class="field col-12 md:col-3">
								<label htmlFor="decricao">Subgrupo</label>
								<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
									name="identificacao" placeholder="Insira a descrição"
									[(ngModel)]="subgrupo.descricao" />
							</div>
							<div class="field col-3 md:col-3" *ngIf="grupo.planoContaEmpresa?.codigo === 4">
								<label htmlFor="rateio">Rateio básico</label>
	
								<p-inputNumber [(ngModel)]="subgrupo.rateioBasico" suffix="%" name="rateio" [max]="100"
									[minFractionDigits]="2" [maxFractionDigits]="2">
								</p-inputNumber>
							</div>
							<div class="field col-12 md:col-2">
								<button type="button" pButton icon="pi pi-check" class="p-button-success mt-5"
									 (click)="adicionarSubgrupo()" pTooltip="Adicionar Subgrupo"
									[disabled]="!subgrupo.descricao">
								</button>
							</div>

							<div class="field col-12 md:col-12">
								<p-table #dt1 [value]="listaSubgrupos" dataKey="id" [rows]="10" [rowHover]="true"
									styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
									styleClass=" p-datatable-sm">
									<ng-template pTemplate="header">
										<tr>
											<th>
												<div class="flex justify-content-between align-items-center">
													Descrição
												</div>
											</th>
											<th *ngIf="grupo.planoContaEmpresa?.codigo === 4">
												<div class="flex justify-content-between align-items-center">
													Rateio Básico
												</div>
											</th>
											<th>
												<div class="flex justify-content-between align-items-center">
													Ações
												</div>
											</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-item let-i="rowIndex">
										<tr>
											<td>
												<input oninput="this.value = this.value.toUpperCase();" pInputText
													type="text" name="descricao{{i}}" [(ngModel)]="item.descricao" />
											</td>
											<td *ngIf="grupo.planoContaEmpresa?.codigo === 4">
												<p-inputNumber [(ngModel)]="item.rateioBasico" suffix="%" name="rateio{{i}}"
													[max]="100" [minFractionDigits]="2" [maxFractionDigits]="2">
												</p-inputNumber>
											</td>
											<td>
												<button pButton pRipple pTooltip="Excluir" type="button" icon="pi pi-trash"
													class="p-button-danger mr-2 mb-2 sm" (click)="excluirSubgrupo(item)"></button>
											</td>
	
										</tr>
									</ng-template>
								</p-table>
								
							</div>

						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Atualizar"
								class="p-button-outlined p-button-success md:w-9rem"
								[disabled]="!f.valid || !grupo" (click)="atualizarGrupo()">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="button" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
									class="p-button-outlined p-button-success md:w-9rem" disabled>
								</button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
							  class="p-button-outlined md:w-9rem" routerLink="/apps/grupo">
							</button>
						</div>
					</div>
				</div>
			</form>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>

			<p-dialog header="Atenção" [(visible)]="modalNenhumSubgrupo" [style]="{width: '40vw'}"
				[baseZIndex]="10000" [resizable]="false" [modal]="true" [draggable]="false">
				<p>Não há subgrupos cadastrados para o Grupo. Para salvar é necessário pelo menos um.
				</p>
				<ng-template pTemplate="footer">
					<p-button icon="pi pi-check" (click)="modalNenhumSubgrupo=false" label="OK"
						styleClass="p-button-primary"></p-button>
				</ng-template>
			</p-dialog>
			<p-dialog header="Grupo Excluído" [(visible)]="exibirRedirecionarExcluido" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true"
                (onHide)="redirecionarListagem()">
                <div class="flex justify-content-between">
                    <p>
                        Você será redirecionado para a listagem
                    </p>
                    <button type="button" pButton label="OK" class="p-button-primary"
                        routerLink="/apps/grupo"></button>
                </div>
            </p-dialog>
		</div>
	</div>
</div>